/**
 * 季节展示与后端枚举对齐。
 * 后端存 `fall`；历史/本地可能出现 `autumn`。展示统一为 Fall。
 */

export function normalizeSeasonValue(raw: string): string {
  const value = raw.trim().toLowerCase()
  if (!value) return ''
  if (value === 'autumn' || value === 'fall') return 'fall'
  return value
}

export function normalizeSeasonValues(raw: string[] | undefined | null): string[] {
  if (!raw?.length) return []
  const seen = new Set<string>()
  const result: string[] = []
  for (const item of raw) {
    const value = normalizeSeasonValue(String(item))
    if (!value || seen.has(value)) continue
    seen.add(value)
    result.push(value)
  }
  return result
}

export function formatSeasonDisplayLabel(raw: string): string {
  const value = normalizeSeasonValue(raw)
  if (!value) return ''
  if (value === 'fall') return 'Fall'
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export function formatSeasonDisplayLabels(raw: string[] | undefined | null): string[] {
  return normalizeSeasonValues(raw).map((s) => formatSeasonDisplayLabel(s))
}
